module.exports = __webpack_public_path__ + "media/images/city_img/u-5c02481f67f1a168418458139cb247ff.jpg";